import { mapGetters } from "vuex";
import { find } from "lodash";

export function HasGroupMixin(groupName) {
    var PropName = "UserIs" + groupName.replace(/ /g, "_");

    return {
        computed: {
            ...mapGetters("AuthModule", ["currentUser"]),
            [PropName]() {
                const user = this.currentUser;

                if (!user) {
                    return false; // No User no Groups so cant be!
                }

                return !!find(user.groups || [], {
                    name: groupName,
                });
            },
        },
    };
}
